import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { MetaPixel } from './components/MetaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Audience } from './components/Audience';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    document.documentElement.lang = 'pl';
    document.title = 'MATEMATYKA GOTOWA™ – Gotowe lekcje matematyki od klasy 4 do matury';
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3ihuyk4ft23e4">
      <div lang="pl" className="w-full bg-stone-50 font-sans text-slate-900 antialiased" data-id="element-1" data-mp="3mkrd9k285fcs">
        <MetaPixel data-id="element-2" data-mp="3rbra6pbcfxfa" />
        <CountdownBar data-id="element-3" data-mp="3rdas0kcnegj6" />
        <main data-id="element-4" data-mp="3rcsuzli5vya7">
          <Hero data-id="element-5" data-mp="3reccfffk0fdk" />
          <StatsBar data-id="element-6" data-mp="5yi8qe3h5da" />
          <Difference data-id="element-7" data-mp="6htxpd5ixiv" />
          <Recognize data-id="element-8" data-mp="4n5i12o8na1" />
          <WhatsInside data-id="element-9" data-mp="56lhc8rh1lf" />
          <InsidePages data-id="element-10" data-mp="2zl3azit8d249" />
          <Bonuses data-id="element-11" data-mp="2zllijblcf2rh" />
          <HowItWorks data-id="element-12" data-mp="2zmepackaxs9m" />
          <Audience data-id="element-13" data-mp="2zmwhmy3ufmc9" />
          <Offer data-id="element-14" data-mp="2znfy0adui2o6" />
          <Guarantee data-id="element-15" data-mp="33mf6g4yschkd" />
          <Faq data-id="element-16" data-mp="33nq6put0v76q" />
          <FinalCta data-id="element-17" data-mp="33n6zb810016y" />
        </main>
        <Footer data-id="element-18" data-mp="33ohzyyz5cstu" />
      </div>
    </MotionConfig>;
}